import { createGcpAppStoreWithoutSaga, IGcpAppStore } from "./store";
import io from "./io";

const store: IGcpAppStore = createGcpAppStoreWithoutSaga(io);

export default store as IGcpAppStore;
